export const LANGS = [
  { code: "hu", label: "HU", name: "Magyar" },
  { code: "en", label: "EN", name: "English" },
  { code: "de", label: "DE", name: "Deutsch" },
];

export const translations = {
  hu: {
    meta: {
      title: "Chiptuning Fájlszolgáltatás Magyarország | Tuning Files, Stage 1-3, Dyno Pro — TuningFiles.hu",
      description:
        "TuningFiles.hu — prémium chiptuning fájlszolgáltatás (fileservice) német minőségben. Egyedi ECU tuning fájlok: Stage 1, Stage 2, Stage 3, Dyno Pro fékpad fájlok. Autotuner Flex & Slave partnerprogram műhelyeknek és tunereknek. #1 fileservice Magyarországon.",
      keywords:
        "chiptuning fájl, chiptuning fájlszolgáltatás, fileservice, tuning files, tuning fájl, ECU tuning, Stage 1, Stage 2, Stage 3, Dyno Pro, fékpad fájl, autotuner flex, autotuner slave, chiptuning partner, tuning partnerprogram, chiptuning Magyarország",
    },
    nav: {
      solutions: "Megoldások",
      configurator: "Konfigurátor",
      partner: "Partnerprogram",
      manifesto: "Minőség",
      faq: "GYIK",
      blog: "Tudástár",
      contact: "Kapcsolat",
      cta: "Ajánlatkérés",
    },
    hero: {
      badge: "PRÉMIUM NÉMET MINŐSÉG",
      title1: "MAXIMÁLIS",
      title2: "MINŐSÉG.",
      title3: "MINDEN FÁJLBAN.",
      subtitle:
        "Prémium ECU chiptuning fájlszolgáltatás műhelyeknek és tunereknek. Stage 1–3, Dyno Pro fékpad fájlok és Autotuner Flex támogatás — német precizitással, magyar sebességgel.",
      ctaPrimary: "Fájl igénylése",
      ctaSecondary: "Megoldások",
      stat1: "Fájl leszállítva",
      stat2: "Átlagos átfutás",
      stat3: "Partnerműhely",
    },
    marquee: "STAGE 1 • STAGE 2 • STAGE 3 • DYNO PRO • AUTOTUNER FLEX • ",
    solutions: {
      overline: "MEGOLDÁSOK",
      title: "Teljesítmény, fájlban kódolva.",
      subtitle:
        "Minden fájl egyedileg kalibrált, valós adatokból építve. Nincs kompromisszum, nincs generikus térkép.",
      items: [
        {
          tag: "01",
          name: "Stage 1",
          desc: "Gyári hardveren elérhető maximum. Optimalizált nyomaték, tisztább gázreakció, alacsonyabb fogyasztás.",
          points: ["+20-30% teljesítmény", "Gyári megbízhatóság", "OBD flash"],
        },
        {
          tag: "02",
          name: "Stage 2",
          desc: "Hardveres módosításokhoz (letöltő, intercooler, szűrő) hangolt fájl a maximális kihasználtságért.",
          points: ["Hardver-optimalizált", "Egyedi kalibráció", "Sport kipufogó ready"],
        },
        {
          tag: "03",
          name: "Stage 3",
          desc: "Verseny szintű, turbó- és belsőmotor-módosításokhoz. A határok feszegetése teljes kontrollal.",
          points: ["Motorsport szint", "Hibrid turbó support", "Egyedi projekt"],
        },
        {
          tag: "04",
          name: "Dyno Pro",
          desc: "Fékpadon validált fájlok. Valós mérés, valós görbe, dokumentált teljesítmény.",
          points: ["Fékpad validálva", "Görbe dokumentáció", "Optionális DPF/EGR"],
        },
      ],
    },
    configurator: {
      overline: "ÉLŐ KONFIGURÁTOR",
      title: "Válaszd ki az autód. Lásd a potenciált.",
      subtitle:
        "Válaszd ki a márkát, modellt és motort — azonnal megkapod a várható teljesítménynövekedést és a fékpadi görbét.",
    },
    partner: {
      overline: "AUTOTUNER FLEX / SLAVE",
      title: "LÉGY A PARTNERÜNK.",
      subtitle:
        "Csatlakozz a partnerhálózatunkhoz mint műhely vagy tuner. Autotuner Flex és Slave támogatás, gyors fájlleszállítás és technikai háttér — hogy Te a munkára koncentrálhass.",
      points: [
        "Prioritásos fájlleszállítás 24/7 support-tal",
        "Autotuner Flex & Slave teljes körű támogatás",
        "Nagykereskedelmi partnerárak és jutalék",
        "Fehércímkés (white-label) megoldás a márkádnak",
      ],
      cta: "Partner leszek",
      more: "Részletek",
    },
    manifesto: {
      overline: "A NÉMET MINŐSÉG",
      title: "Miért mi?",
      chapters: [
        {
          num: "01",
          title: "Precizitás alapból",
          text: "Minden fájl kézzel, egyedileg kalibrált valós adatok alapján. Nincs automata térkép, nincs másolat — csak dokumentált, biztonságos teljesítmény.",
        },
        {
          num: "02",
          title: "Sebesség kompromisszum nélkül",
          text: "Átlagos átfutásunk órákban mérhető, nem napokban. A műhelyed nem áll meg — az ügyfeled aznap indul.",
        },
        {
          num: "03",
          title: "Biztonság mindenekelőtt",
          text: "Minden térkép a motor tűréshatárain belül marad. Hosszú távú megbízhatóság, garantált visszaállíthatóság.",
        },
      ],
    },
    faq: {
      overline: "GYIK",
      title: "Gyakori kérdések",
      subtitle:
        "Minden, amit a chiptuning fájlszolgáltatásról, a tuning fájlokról és a partnerprogramról tudnod kell.",
      items: [
        {
          q: "Mi az a chiptuning fájlszolgáltatás (fileservice)?",
          a: "A chiptuning fájlszolgáltatás során az autód ECU-jából kiolvasott eredeti fájlt egyedileg optimalizáljuk, majd visszaküldjük a kész tuning fájlt. Te csak beolvasod és visszaírod — a teljesítménynövelést mi végezzük távolról, gyorsan és biztonságosan.",
        },
        {
          q: "Mi a különbség a Stage 1, Stage 2 és Stage 3 tuning között?",
          a: "A Stage 1 gyári hardveren nyújt maximumot, a Stage 2 hardveres módosításokhoz (letöltőcső, intercooler, sportszűrő) van hangolva, a Stage 3 pedig verseny szintű turbó- és motormódosításokhoz készül.",
        },
        {
          q: "Mennyi idő alatt készül el egy tuning fájl?",
          a: "Az átlagos átfutási időnk kevesebb mint 2 óra. A legtöbb Stage 1 fájlt aznap leszállítjuk, így a műhelyed nem áll meg és az ügyfeled még aznap elviheti az autót.",
        },
        {
          q: "Mit jelent a Dyno Pro / fékpad fájl?",
          a: "A Dyno Pro fájlokat fékpadon validáljuk. Valós mérés alapján dokumentált teljesítménygörbét kapsz, hogy az ügyfélnek bizonyítható legyen a tényleges eredmény.",
        },
        {
          q: "Hogyan lehetek partner (Autotuner Flex / Slave)?",
          a: "Csatlakozz partnerhálózatunkhoz műhelyként vagy tunerként. Teljes Autotuner Flex és Slave támogatást, prioritásos fájlleszállítást, nagykereskedelmi árakat és white-label megoldást biztosítunk. Írj nekünk WhatsApp-on a kezdéshez.",
        },
        {
          q: "Biztonságos a chiptuning? Megmarad a megbízhatóság?",
          a: "Igen. Minden tuning fájl a motor gyári tűréshatárain belül marad, és bármikor visszaállítható a gyári állapot. Csak dokumentált, tesztelt térképeket szállítunk német minőségben.",
        },
      ],
    },
    contact: {
      overline: "KAPCSOLAT",
      title: "Kezdjük el.",
      subtitle: "Írj vagy hívj — a fájlod már úton van.",
      whatsapp: "WhatsApp chat",
      email: "Email küldése",
      phone: "Hívj most",
      copied: "Vágólapra másolva",
    },
    footer: {
      tagline: "Prémium chiptuning fájlszolgáltatás. Német minőség, magyar szív.",
      rights: "Minden jog fenntartva.",
      impressum: "Impresszum",
      privacy: "Adatvédelem",
      cookieSettings: "Cookie beállítások",
    },
    legalUi: { updated: "Állapot", back: "Vissza a főoldalra" },
    cookie: {
      title: "Cookie-kat használunk",
      text: "Ez a weboldal a működéshez szükséges cookie-kat, valamint – a hozzájárulásoddal – névtelen statisztikai cookie-kat használ.",
      accept: "Összes elfogadása",
      reject: "Csak szükséges",
      settings: "Cookie beállítások",
      privacy: "Adatvédelem",
    },
  },

  en: {
    meta: {
      title: "TuningFiles.hu — #1 Chiptuning File Service | Stage 1-3, Dyno Pro",
      description:
        "Premium ECU chiptuning file service with German quality. Stage 1, Stage 2, Stage 3 tuning, Dyno Pro dyno files and Autotuner Flex partner program for workshops and tuners in Hungary.",
      keywords:
        "chiptuning file, ECU tuning, file service, Stage 1, Stage 2, Stage 3, dyno, autotuner flex, tuning Hungary",
    },
    nav: {
      solutions: "Solutions",
      configurator: "Configurator",
      partner: "Partner Program",
      manifesto: "Quality",
      faq: "FAQ",
      blog: "Blog",
      contact: "Contact",
      cta: "Get a quote",
    },
    hero: {
      badge: "PREMIUM GERMAN QUALITY",
      title1: "MAXIMUM",
      title2: "QUALITY.",
      title3: "IN EVERY FILE.",
      subtitle:
        "Premium ECU chiptuning file service for workshops and tuners. Stage 1–3, Dyno Pro dyno files and Autotuner Flex support — German precision, Hungarian speed.",
      ctaPrimary: "Request a file",
      ctaSecondary: "Solutions",
      stat1: "Files delivered",
      stat2: "Average turnaround",
      stat3: "Partner workshops",
    },
    marquee: "STAGE 1 • STAGE 2 • STAGE 3 • DYNO PRO • AUTOTUNER FLEX • ",
    solutions: {
      overline: "SOLUTIONS",
      title: "Performance, coded into a file.",
      subtitle:
        "Every file is individually calibrated from real data. No compromise, no generic maps.",
      items: [
        {
          tag: "01",
          name: "Stage 1",
          desc: "The maximum on stock hardware. Optimized torque, cleaner throttle response, lower consumption.",
          points: ["+20-30% power", "Stock reliability", "OBD flash"],
        },
        {
          tag: "02",
          name: "Stage 2",
          desc: "Tuned files for hardware mods (downpipe, intercooler, filter) to fully exploit your build.",
          points: ["Hardware optimized", "Custom calibration", "Sport exhaust ready"],
        },
        {
          tag: "03",
          name: "Stage 3",
          desc: "Race-grade files for turbo and internal engine mods. Pushing limits with full control.",
          points: ["Motorsport level", "Hybrid turbo support", "Custom project"],
        },
        {
          tag: "04",
          name: "Dyno Pro",
          desc: "Dyno-validated files. Real measurement, real curve, documented performance.",
          points: ["Dyno validated", "Curve documentation", "Optional DPF/EGR"],
        },
      ],
    },
    configurator: {
      overline: "LIVE CONFIGURATOR",
      title: "Pick your car. See the potential.",
      subtitle:
        "Select make, model and engine — instantly get expected power gains and the dyno curve.",
    },
    partner: {
      overline: "AUTOTUNER FLEX / SLAVE",
      title: "BECOME OUR PARTNER.",
      subtitle:
        "Join our partner network as a workshop or tuner. Autotuner Flex and Slave support, fast file delivery and full technical backing — so you can focus on the work.",
      points: [
        "Priority file delivery with 24/7 support",
        "Full Autotuner Flex & Slave support",
        "Wholesale partner pricing and commission",
        "White-label solution for your brand",
      ],
      cta: "Become a partner",
      more: "Learn more",
    },
    manifesto: {
      overline: "GERMAN QUALITY",
      title: "Why us?",
      chapters: [
        {
          num: "01",
          title: "Precision by default",
          text: "Every file is hand-calibrated individually from real data. No auto maps, no copies — only documented, safe performance.",
        },
        {
          num: "02",
          title: "Speed without compromise",
          text: "Our average turnaround is measured in hours, not days. Your shop keeps moving — your customer drives away the same day.",
        },
        {
          num: "03",
          title: "Safety first",
          text: "Every map stays within the engine's tolerances. Long-term reliability, guaranteed reversibility.",
        },
      ],
    },
    faq: {
      overline: "FAQ",
      title: "Frequently asked questions",
      subtitle:
        "Everything you need to know about our chiptuning file service, tuning files and partner program.",
      items: [
        {
          q: "What is a chiptuning file service (fileservice)?",
          a: "With a chiptuning file service we individually optimize the original file read from your car's ECU and send back the finished tuning file. You just read and flash it — we handle the power increase remotely, fast and safely.",
        },
        {
          q: "What is the difference between Stage 1, Stage 2 and Stage 3 tuning?",
          a: "Stage 1 delivers the maximum on stock hardware, Stage 2 is tuned for hardware mods (downpipe, intercooler, sport filter), and Stage 3 is built for race-level turbo and engine modifications.",
        },
        {
          q: "How long does a tuning file take?",
          a: "Our average turnaround is under 2 hours. Most Stage 1 files are delivered the same day, so your workshop keeps moving and your customer drives away the same day.",
        },
        {
          q: "What is a Dyno Pro / dyno file?",
          a: "Dyno Pro files are validated on a dyno. You get a documented power curve based on a real measurement, so the actual result is provable to your customer.",
        },
        {
          q: "How can I become a partner (Autotuner Flex / Slave)?",
          a: "Join our partner network as a workshop or tuner. We provide full Autotuner Flex and Slave support, priority file delivery, wholesale pricing and a white-label solution. Message us on WhatsApp to get started.",
        },
        {
          q: "Is chiptuning safe? Does reliability stay intact?",
          a: "Yes. Every tuning file stays within the engine's factory tolerances and can be reverted to stock anytime. We only deliver documented, tested maps in German quality.",
        },
      ],
    },
    contact: {
      overline: "CONTACT",
      title: "Let's start.",
      subtitle: "Message or call — your file is already on the way.",
      whatsapp: "WhatsApp chat",
      email: "Send email",
      phone: "Call now",
      copied: "Copied to clipboard",
    },
    footer: {
      tagline: "Premium chiptuning file service. German quality, Hungarian heart.",
      rights: "All rights reserved.",
      impressum: "Imprint",
      privacy: "Privacy",
      cookieSettings: "Cookie settings",
    },
    legalUi: { updated: "Last updated", back: "Back to home" },
    cookie: {
      title: "We use cookies",
      text: "This website uses technically necessary cookies and — with your consent — anonymous statistics cookies.",
      accept: "Accept all",
      reject: "Only necessary",
      settings: "Cookie settings",
      privacy: "Privacy",
    },
  },

  de: {
    meta: {
      title: "TuningFiles.hu — Nr. 1 Chiptuning Fileservice | Stage 1-3, Dyno Pro",
      description:
        "Premium ECU Chiptuning Fileservice in deutscher Qualität. Stage 1, Stage 2, Stage 3 Tuning, Dyno Pro Prüfstand-Files und Autotuner Flex Partnerprogramm für Werkstätten und Tuner in Ungarn.",
      keywords:
        "chiptuning file, ECU tuning, fileservice, Stage 1, Stage 2, Stage 3, dyno, prüfstand, autotuner flex, tuning Ungarn",
    },
    nav: {
      solutions: "Lösungen",
      configurator: "Konfigurator",
      partner: "Partnerprogramm",
      manifesto: "Qualität",
      faq: "FAQ",
      blog: "Blog",
      contact: "Kontakt",
      cta: "Angebot anfragen",
    },
    hero: {
      badge: "PREMIUM DEUTSCHE QUALITÄT",
      title1: "MAXIMALE",
      title2: "QUALITÄT.",
      title3: "IN JEDEM FILE.",
      subtitle:
        "Premium ECU Chiptuning Fileservice für Werkstätten und Tuner. Stage 1–3, Dyno Pro Prüfstand-Files und Autotuner Flex Support — deutsche Präzision, ungarisches Tempo.",
      ctaPrimary: "File anfragen",
      ctaSecondary: "Lösungen",
      stat1: "Files geliefert",
      stat2: "Ø Bearbeitungszeit",
      stat3: "Partnerwerkstätten",
    },
    marquee: "STAGE 1 • STAGE 2 • STAGE 3 • DYNO PRO • AUTOTUNER FLEX • ",
    solutions: {
      overline: "LÖSUNGEN",
      title: "Leistung, codiert in ein File.",
      subtitle:
        "Jedes File wird individuell aus echten Daten kalibriert. Keine Kompromisse, keine generischen Maps.",
      items: [
        {
          tag: "01",
          name: "Stage 1",
          desc: "Das Maximum auf Serienhardware. Optimiertes Drehmoment, sauberere Gasannahme, geringerer Verbrauch.",
          points: ["+20-30% Leistung", "Serienzuverlässigkeit", "OBD Flash"],
        },
        {
          tag: "02",
          name: "Stage 2",
          desc: "Abgestimmte Files für Hardware-Mods (Downpipe, Ladeluftkühler, Filter) für maximale Ausnutzung.",
          points: ["Hardware-optimiert", "Individuelle Kalibrierung", "Sportauspuff ready"],
        },
        {
          tag: "03",
          name: "Stage 3",
          desc: "Files auf Rennsportniveau für Turbo- und Motorumbauten. Grenzen ausloten mit voller Kontrolle.",
          points: ["Motorsport-Niveau", "Hybridturbo-Support", "Individuelles Projekt"],
        },
        {
          tag: "04",
          name: "Dyno Pro",
          desc: "Prüfstand-validierte Files. Echte Messung, echte Kurve, dokumentierte Leistung.",
          points: ["Prüfstand validiert", "Kurvendokumentation", "Optional DPF/EGR"],
        },
      ],
    },
    configurator: {
      overline: "LIVE KONFIGURATOR",
      title: "Wähle dein Auto. Sieh das Potenzial.",
      subtitle:
        "Wähle Marke, Modell und Motor — erhalte sofort die erwartete Mehrleistung und die Prüfstandskurve.",
    },
    partner: {
      overline: "AUTOTUNER FLEX / SLAVE",
      title: "WERDE UNSER PARTNER.",
      subtitle:
        "Werde Teil unseres Partnernetzwerks als Werkstatt oder Tuner. Autotuner Flex und Slave Support, schnelle Fileauslieferung und volle technische Unterstützung — damit du dich auf die Arbeit konzentrieren kannst.",
      points: [
        "Priorisierte Fileauslieferung mit 24/7 Support",
        "Voller Autotuner Flex & Slave Support",
        "Großhandelspreise und Provision für Partner",
        "White-Label-Lösung für deine Marke",
      ],
      cta: "Partner werden",
      more: "Mehr erfahren",
    },
    manifesto: {
      overline: "DEUTSCHE QUALITÄT",
      title: "Warum wir?",
      chapters: [
        {
          num: "01",
          title: "Präzision von Grund auf",
          text: "Jedes File wird individuell von Hand kalibriert, auf Basis echter Daten. Keine Auto-Maps, keine Kopien — nur dokumentierte, sichere Leistung.",
        },
        {
          num: "02",
          title: "Tempo ohne Kompromisse",
          text: "Unsere Bearbeitungszeit misst sich in Stunden, nicht in Tagen. Deine Werkstatt läuft weiter — dein Kunde fährt am selben Tag.",
        },
        {
          num: "03",
          title: "Sicherheit zuerst",
          text: "Jede Map bleibt innerhalb der Motortoleranzen. Langfristige Zuverlässigkeit, garantierte Rückrüstbarkeit.",
        },
      ],
    },
    faq: {
      overline: "FAQ",
      title: "Häufige Fragen",
      subtitle:
        "Alles, was du über unseren Chiptuning Fileservice, die Tuning-Files und das Partnerprogramm wissen musst.",
      items: [
        {
          q: "Was ist ein Chiptuning Fileservice?",
          a: "Beim Chiptuning Fileservice optimieren wir das aus dem Steuergerät (ECU) ausgelesene Originalfile individuell und schicken dir das fertige Tuning-File zurück. Du liest nur aus und flashst wieder — die Mehrleistung erstellen wir remote, schnell und sicher.",
        },
        {
          q: "Was ist der Unterschied zwischen Stage 1, Stage 2 und Stage 3 Tuning?",
          a: "Stage 1 holt das Maximum aus Serienhardware, Stage 2 ist auf Hardware-Mods (Downpipe, Ladeluftkühler, Sportfilter) abgestimmt, und Stage 3 ist für Turbo- und Motorumbauten auf Rennsportniveau gedacht.",
        },
        {
          q: "Wie lange dauert ein Tuning-File?",
          a: "Unsere durchschnittliche Bearbeitungszeit liegt unter 2 Stunden. Die meisten Stage-1-Files liefern wir am selben Tag, damit deine Werkstatt weiterläuft und dein Kunde noch am selben Tag fährt.",
        },
        {
          q: "Was bedeutet Dyno Pro / Prüfstand-File?",
          a: "Dyno Pro Files werden auf dem Prüfstand validiert. Du erhältst eine dokumentierte Leistungskurve auf Basis einer echten Messung, damit das tatsächliche Ergebnis für deinen Kunden nachweisbar ist.",
        },
        {
          q: "Wie werde ich Partner (Autotuner Flex / Slave)?",
          a: "Werde Teil unseres Partnernetzwerks als Werkstatt oder Tuner. Wir bieten vollen Autotuner Flex und Slave Support, priorisierte Fileauslieferung, Großhandelspreise und eine White-Label-Lösung. Schreib uns auf WhatsApp für den Start.",
        },
        {
          q: "Ist Chiptuning sicher? Bleibt die Zuverlässigkeit erhalten?",
          a: "Ja. Jedes Tuning-File bleibt innerhalb der Werkstoleranzen des Motors und lässt sich jederzeit auf den Serienstand zurücksetzen. Wir liefern nur dokumentierte, getestete Maps in deutscher Qualität.",
        },
      ],
    },
    contact: {
      overline: "KONTAKT",
      title: "Lass uns starten.",
      subtitle: "Schreib oder ruf an — dein File ist schon unterwegs.",
      whatsapp: "WhatsApp Chat",
      email: "E-Mail senden",
      phone: "Jetzt anrufen",
      copied: "In Zwischenablage kopiert",
    },
    footer: {
      tagline: "Premium Chiptuning Fileservice. Deutsche Qualität, ungarisches Herz.",
      rights: "Alle Rechte vorbehalten.",
      impressum: "Impressum",
      privacy: "Datenschutz",
      cookieSettings: "Cookie-Einstellungen",
    },
    legalUi: { updated: "Stand", back: "Zurück zur Startseite" },
    cookie: {
      title: "Wir verwenden Cookies",
      text: "Diese Website verwendet technisch notwendige Cookies sowie – mit deiner Einwilligung – anonyme Statistik-Cookies.",
      accept: "Alle akzeptieren",
      reject: "Nur notwendige",
      settings: "Cookie-Einstellungen",
      privacy: "Datenschutz",
    },
  },
};

export const CONTACT = {
  email: "info@tuningfiles.hu",
  phone: "+49 1522 5373841",
  phoneRaw: "+4915225373841",
  whatsapp: "4915225373841",
};

